module.exports = __webpack_public_path__ + "img/oli-3.3fb9ee49.png";